import themeBlue from '../images/themeBlue.png'
import themeGreen from '../images/themeGreen.png'
import themeGrey from '../images/themeGrey.png'
import themeNavy from '../images/themeNavy.png'
import themeSmoke from '../images/themeSmoke.png'
import themeViolet from '../images/themeViolet.png'
import themeAurora from '../images/themeAurora.png'
import themeJuno from '../images/themeJuno.jpg'

export const backgroundThemes = {
  THEME_1: { name: 'Blue', image: themeBlue },
  THEME_2: { name: 'Green', image: themeGreen },
  THEME_3: { name: 'Grey', image: themeGrey },
  THEME_4: { name: 'Navy', image: themeNavy },
  THEME_5: {
    name: 'Marble',
    gradient: 'linear-gradient(145deg,rgb(149, 156, 163) 0%, #f8f9fa 50%,rgba(243, 249, 255, 0.85) 100%)',
    isLight: true
  },
  THEME_6: {
    name: 'Graphite',
    gradient: 'linear-gradient(145deg, #6c757d 0%, #a9afb5 50%, #868e96 100%)',
    isLight: true
  },
  THEME_7: { name: 'Teal', image: themeSmoke },
  THEME_8: { name: 'Violet', image: themeViolet },
  THEME_9: {
    name: 'Sky Blue',
    gradient: 'linear-gradient(135deg, #3d8fea 0%, #c4d9fa 50%, #6dc0fc 100%)',
    isLight: true
  },
  THEME_10: {
    name: 'White',
    gradient: 'linear-gradient(135deg, #fff 0%, #fff 50%, #fff 100%)',
    isLight: true
  },
  THEME_11: {
    name: 'Aurora',
    image: themeAurora
  },
  THEME_12: {
    name: 'Juno',
    image: themeJuno
  }
}

export const themeColors = {
  Blue: '#1976d2',
  Green: '#388e3c',
  Grey: '#757575',
  Navy: '#303f9f',
  Marble: '#959ca3',
  Graphite: '#6c757d',
  Teal: '#00796b',
  Violet: '#7b1fa2',
  'Sky Blue': '#3d8fea',
  White: '#7b1fa2',
  Aurora: '#7b68ee'
}

export const DEFAULT_DARK_TITLE_TEXT_COLOR = 'rgb(23, 12, 102)'
export const DEFAULT_DARK_MESSAGE_TEXT_COLOR = 'rgba(88, 99, 124, 0.8)'

export const DEFAULT_DARK_TEXT_COLOR = '#1B1B26'
export const DEFAULT_LIGHT_THEME_PLACEHOLDER_COLOR = '#757575'
export const DEFAULT_LIGHT_THEME_CARD_BACKGROUND = 'rgba(255, 255, 255, 0.7)'
export const DEFAULT_LIGHT_THEME_CHECKED_COLOR = '#1976d2'

export const getModuleTheme = (theme, moduleIndex) => {
  // For THEME_11 (Aurora): first module gets the gradient, all others get white
  if (theme === 'THEME_11') {
    return moduleIndex === 0 ? 'THEME_11' : 'THEME_10'
  }
  if (theme === 'THEME_12') {
    return moduleIndex === 0 ? 'THEME_12' : 'THEME_10'
  }
  // For THEME_10 (White): first module gets blue theme for contrast, others stay white
  if (theme === 'THEME_10' && moduleIndex === 0) {
    return 'THEME_1'
  }
  return theme
}
